function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { forEachObjIndexed } from 'ramda';
import { IMPORT_BULK_SERVICE_ATTRIBUTES_UPLOAD_STATUSES } from '../order.details.constants';
var DEFAULT_FORMATTED_FILE_IMPORT_RESULT = _defineProperty(_defineProperty(_defineProperty({}, IMPORT_BULK_SERVICE_ATTRIBUTES_UPLOAD_STATUSES.FAILURE, {
  classes: 'is-error',
  glyph: 'status-pending-filled',
  message: null,
  status: IMPORT_BULK_SERVICE_ATTRIBUTES_UPLOAD_STATUSES.FAILURE
}), IMPORT_BULK_SERVICE_ATTRIBUTES_UPLOAD_STATUSES.PROGRESS, {
  classes: 'is-warning',
  glyph: 'status-progress-filled',
  message: null,
  status: IMPORT_BULK_SERVICE_ATTRIBUTES_UPLOAD_STATUSES.PROGRESS
}), IMPORT_BULK_SERVICE_ATTRIBUTES_UPLOAD_STATUSES.SUCCESS, {
  classes: 'is-success',
  glyph: 'status-complete-filled',
  message: null,
  status: IMPORT_BULK_SERVICE_ATTRIBUTES_UPLOAD_STATUSES.SUCCESS
});
export var generateFormattedFileResult = function generateFormattedFileResult(statusType, message) {
  return Object.assign({}, DEFAULT_FORMATTED_FILE_IMPORT_RESULT[statusType], {
    message: message
  });
};
export var returnExpiredImportBulkServiceAttributesJobsPendingUpdatedStatus = function returnExpiredImportBulkServiceAttributesJobsPendingUpdatedStatus(orderItems, bulkServiceAttributesJobsPendingUpdatedStatus) {
  var jobsToBeRemoved = [];
  forEachObjIndexed(function (jobDetails, jobPricingPlanId) {
    var jobPricingPlanIdAsInt = Number(jobPricingPlanId);
    var orderItem = orderItems[jobDetails.offeringId].find(function (item) {
      return item.pricingPlanId === jobPricingPlanIdAsInt;
    });
    if (orderItem.BulkExtractItemDetail.Modified > jobDetails.dateLastModified) {
      jobsToBeRemoved.push({
        offeringId: jobDetails.offeringId,
        pricingPlanId: jobPricingPlanIdAsInt
      });
    }
  }, bulkServiceAttributesJobsPendingUpdatedStatus);
  return jobsToBeRemoved;
};